module.exports = __webpack_public_path__ + "img/sam-and-joyce.f5577200.png";